// extracted by mini-css-extract-plugin
export default {"container":"BetaAlert_container__YFtdg","first":"BetaAlert_first__yFmi4","dot":"BetaAlert_dot__BGXif","second":"BetaAlert_second__V1c7R","link":"BetaAlert_link__eOplg"};